import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';

import type { SessionLanguage } from '@/services/competencyAssessment';
import { startSession } from '@/services/competencyAssessment';
import { getCATranslations } from '@/services/competencyAssessmentI18n';

const LANGUAGE_OPTIONS: {
  value: SessionLanguage;
  flag: string;
  label: string;
}[] = [
  { value: 'pl', flag: '🇵🇱', label: 'Polski' },
  { value: 'en', flag: '🇬🇧', label: 'English' },
];

export default function CompetencyAssessmentPage() {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState<SessionLanguage>('pl');
  const t = getCATranslations(language);

  const handleStart = async () => {
    setLoading(true);
    try {
      const res = await startSession(language);
      router.push({
        pathname: '/competency-assessment/[id]',
        query: { id: String(res.id) },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen bg-white">
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <h1 className="font-semibold">{t.title}</h1>
          <div className="flex items-center gap-3">
            <Link
              href="/competency-assessment/sessions"
              className="text-sm text-gray-500 hover:text-gray-700"
            >
              {t.allSessions}
            </Link>
            <div className="flex rounded-md border border-gray-200 text-sm">
              {LANGUAGE_OPTIONS.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => setLanguage(opt.value)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 transition-colors first:rounded-l-md last:rounded-r-md ${
                    language === opt.value
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <span>{opt.flag}</span>
                  <span>{opt.label}</span>
                </button>
              ))}
            </div>
            <button
              type="button"
              onClick={handleStart}
              disabled={loading}
              className="rounded bg-blue-600 px-4 py-1.5 text-sm text-white hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? t.starting : t.startSession}
            </button>
          </div>
        </div>
        <div className="flex flex-1 items-center justify-center text-sm text-gray-400">
          {t.clickToStart}
        </div>
      </div>
    </div>
  );
}
